import { Button, CircularProgress } from "@mui/material";

interface TSPrimaryButtonProps {
  text: string;
  onClick: any;
  disabled?: boolean;
  loading?: boolean;
  sx?: any;
}

const TSPrimaryButton = ({ text, onClick, disabled, loading, sx }: TSPrimaryButtonProps) => (
  <Button
    onClick={onClick}
    variant="contained"
    sx={{
      textTransform: "none",
      borderRadius: "4px",
      fontWeight: "bold",
      "&:focus": {
        outline: "none",
      },
      ...sx,
    }}
    disabled={disabled}
  >
    {loading ? <CircularProgress size={"18px"} style={{ color: "#FFF" }} /> : text}
  </Button>
);

export default TSPrimaryButton;
